const DEFAULT_HEADER_OFFSET = 160

export function filterItemsByLetter(itemsByLetter, query) {
  const normalized = query.toLowerCase().trim()
  const filtered = {}

  Object.entries(itemsByLetter).forEach(([letter, items]) => {
    const visible = items.filter((item) => !normalized || item.searchName.includes(normalized))
    if (visible.length > 0) {
      filtered[letter] = visible
    }
  })

  return filtered
}

export function countVisibleItems(filteredGroups) {
  return Object.values(filteredGroups).reduce((sum, items) => sum + items.length, 0)
}

export function scrollToLetter(letter, headerOffset = DEFAULT_HEADER_OFFSET) {
  const target = document.querySelector(`#letter-${letter}`)
  if (!target) return

  const elementPosition = target.getBoundingClientRect().top
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  })
}
